import * as React from 'react';
import { withRouter } from 'react-router-dom';

import { inject, observer } from 'mobx-react';

import { getConfig, URLS } from '@constants';

import { EStore } from '@enums';

import { commonWillUnmount } from '@decorators';

import { FullscreenAppHeader, FullscreenApp, JSAPI } from '@components';

import { IAppMainPageProps } from './types';

import * as s from './AppMainPage.scss';

@inject(
	EStore.APP,
	EStore.COUNTERS,
	EStore.CURRENT_USER,
	EStore.MAIN_MENU_APPS,
)
@observer
@commonWillUnmount()
export class AppMainPageContainer extends React.PureComponent<IAppMainPageProps> {

	closePage = () => {
		const { appStore, history } = this.props;

		appStore.resetActiveApp();
		history.push(URLS.APPS);
	};

	render() {
		const { appStore, currentUserStore } = this.props;
		const app = appStore.activeApp;

		if (!app) {
			return null;
		}

		return <div className={s.container}>
			{getConfig().isAndroidApp
				? null
				: <div className={s.header}>
					<FullscreenAppHeader
						appName={app.name}
						onClose={this.closePage}
					/>
				</div>}

			<div className={s.app}>
				<FullscreenApp
					url={app.url}
					appId={app.id}
				/>
			</div>

			<JSAPI
				app={app}
				appURL={app.url}
				privateKey={app.privateKey}
				currentUser={currentUserStore.currentUser}
				notAppFriends={appStore.notAppFriends}
				fetchNotAppFriends={appStore.fetchNotAppFriends}
				inviteNotAppFriends={appStore.inviteNotAppFriends}
				makeStreamPost={appStore.makeStreamPost}
			/>
		</div>;
	}

}

export const AppMainPage = withRouter(AppMainPageContainer);
